import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from './../../../../../app.config'
import axios from 'axios'
import toast from 'react-hot-toast'

export const allPayrollRequests = createAsyncThunk(
  'reports/allPayrollRequests',
  async (params) => {
    const response = await axios.get(baseUrl() + '/payroll-requests', {
      params
    })
    return {
      allPayrollRequests: response?.data?.data || [],
      totalPages: response?.data?.count?.total || 0
    }
  }
)

export const updatePayrollRequest = createAsyncThunk(
  'user/updatePayrollRequest',
  async ({ id, status, reason, rejectionReason, file }) => {
    try {
      const formData = new FormData()
      formData.append('status', status)
      const rr = rejectionReason ?? reason
      if (rr !== undefined && rr !== null)
        formData.append('rejectionReason', rr)
      if (file) formData.append('file', file)

      const response = await axios.put(
        baseUrl() + `/payroll-requests/${id}/status`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      toast.success(
        response?.data?.message || 'Payroll request status updated successfully'
      )
      return response.data
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Error updating payroll status'
      )
      throw error
    }
  }
)

export const payrollRequestsSlice = createSlice({
  name: 'payroll-RequestTopicsMaster',
  initialState: {
    allPayrollRequests: [],
    loader: false,
    params: {
      pageNo: 1,
      pageSize: 25,
      status: ''
    },
    totalPages: 0,
    filterData: {
      status: ''
    },
    clearFilter: true
  },
  reducers: {
    setParams: (state, action) => {
      state.params = action.payload
    },
    setPageNo: (state, action) => {
      state.params.pageNo = action.payload
    },
    setPageSize: (state, action) => {
      state.params.pageSize = action.payload
    },
    setFilterData: (state, action) => {
      if (action.payload === null) {
        state.filterData = null
      } else {
        state.filterData = action.payload
      }
    },
    selectClearFilter: (state, action) => {
      state.clearFilter = action.payload
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(allPayrollRequests.fulfilled, (state, action) => {
        state.loader = false
        state.allPayrollRequests = action.payload.allPayrollRequests
        state.totalPages = action.payload.totalPages
      })
      .addCase(allPayrollRequests.pending, (state) => {
        state.loader = true
      })
      .addCase(allPayrollRequests.rejected, (state) => {
        state.loader = false
      })
  }
})
export const {
  setParams,
  setPageNo,
  setPageSize,
  setFilterData,
  selectClearFilter,
  setLoader
} = payrollRequestsSlice.actions

export default payrollRequestsSlice.reducer
